import { create } from 'zustand';

interface NorthDialogState {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

const useNorthDialogStore = create<NorthDialogState>((set) => ({
  isOpen: false,
  openDialog: () => set({ isOpen: true }),
  closeDialog: () => set({ isOpen: false }),
}));

export default useNorthDialogStore;
